import { AUTH_REFRESH_URL } from '@ha/auth/common/routes';

export const OAUTH_REFRESH_ACCESS_TOKEN_API_ROUTE = `/next/api${AUTH_REFRESH_URL}`;

export interface OauthRefreshAccessTokenResponse {
  accessToken: string;
  expiresAt: number;
}
